import type { Destination } from './destinations';

// Romania destinations. Photos illustrating each actual location.
export const destinationsRomania: Destination[] = [
  {
    id: 1,
    name: 'Bran Castle',
    location: 'Bran, Transylvania',
    region: 'Transylvania',
    description: 'The legendary "Dracula\'s Castle" perched dramatically on a rocky cliff, a Gothic fortress steeped in medieval mystery and breathtaking mountain views.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782754184392_2ae38389.jpeg',
    alt: 'Bran Castle in Transylvania, Romania, famously associated with Dracula. Gothic medieval fortress on a cliff surrounded by Carpathian mountains.',
    price: 'From €110',
    rating: 4.8,
    features: ['Dracula Legend', 'Medieval Fortress', 'Guided Tours'],
    category: 'heritage',
  },
  {
    id: 2,
    name: 'Peleș Castle',
    location: 'Sinaia, Prahova Valley',
    region: 'Transylvania',
    description: 'A Neo-Renaissance jewel nestled in the Carpathian forests, the former royal summer residence dazzles with ornate woodwork, turrets, and opulent interiors.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406711915_8dbdbfed.jpg',
    alt: 'Peleș Castle in Sinaia, Romania, a Neo-Renaissance royal palace with ornate turrets set in the Carpathian forests of the Prahova Valley.',
    price: 'From €95',
    rating: 4.9,
    features: ['Royal Palace', 'Neo-Renaissance', 'Mountain Setting'],
    category: 'heritage',
  },
  {
    id: 3,
    name: 'Transfăgărășan Road',
    location: 'Făgăraș Mountains',
    region: 'Carpathian Mountains',
    description: 'One of the world\'s most spectacular drives, this serpentine alpine road climbs past glacial lakes and dramatic peaks to over 2,000 metres.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406729379_e48b2fcd.jpg',
    alt: 'The winding Transfăgărășan mountain road snaking through the Făgăraș Mountains of the Romanian Carpathians under dramatic alpine peaks.',
    price: 'From €85',
    rating: 4.9,
    features: ['Scenic Drive', 'Bâlea Lake', 'Alpine Passes'],
    category: 'mountain',
  },
  {
    id: 4,
    name: 'Sighișoara Citadel',
    location: 'Sighișoara, Transylvania',
    region: 'Transylvania',
    description: 'A perfectly preserved medieval citadel and UNESCO World Heritage site, with cobbled lanes, pastel houses, and the iconic Clock Tower watching over it all.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783533349713_eee1e46d.jpeg',
    alt: 'The medieval Clock Tower of Sighișoara Citadel, a UNESCO World Heritage town in Transylvania, Romania, with colourful historic houses.',
    price: 'From €70',
    rating: 4.8,
    features: ['UNESCO Site', 'Clock Tower', 'Medieval Old Town'],
    category: 'heritage',
  },
  {
    id: 5,
    name: 'Bucharest Old Town',
    location: 'Bucharest, Muntenia',
    region: 'Wallachia',
    description: 'Romania\'s vibrant capital blends Belle Époque grandeur with a buzzing café culture, from the colossal Palace of the Parliament to leafy boulevards.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757619890_ad412837.jpeg',
    alt: 'Cobbled lanes of Bucharest Old Town with the historic Stavropoleos Monastery in the capital of Romania.',
    price: 'From €65',
    rating: 4.6,
    features: ['Palace of Parliament', 'Café Culture', 'Belle Époque'],
    category: 'heritage',
  },
  {
    id: 6,
    name: 'Painted Monasteries of Bucovina',
    location: 'Bucovina, Suceava',
    region: 'Bucovina',
    description: 'UNESCO-listed monasteries adorned with vivid 15th-century exterior frescoes, masterpieces of Byzantine art glowing in blue and gold among rolling hills.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406795890_6a2ab537.png',
    alt: 'Voroneț Monastery in Bucovina, Romania, a UNESCO painted monastery covered in vivid blue Byzantine frescoes.',
    price: 'From €75',
    rating: 4.9,
    features: ['UNESCO Site', 'Byzantine Frescoes', 'Voroneț Blue'],
    category: 'heritage',
  },
  {
    id: 7,
    name: 'Danube Delta',
    location: 'Tulcea, Dobruja',
    region: 'Danube Delta',
    description: 'Europe\'s largest wetland and a UNESCO Biosphere Reserve, a labyrinth of channels, reed beds, and lakes teeming with pelicans and over 300 bird species.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757845412_836211b0.jpeg',
    alt: 'Pelicans gliding across the reed-lined channels of the Danube Delta in Romania, a UNESCO Biosphere Reserve and Europe\'s largest wetland.',
    price: 'From €90',
    rating: 4.8,
    features: ['Biosphere Reserve', 'Birdwatching', 'Boat Safaris'],
    category: 'nature',
  },
  {
    id: 8,
    name: 'Brașov & Tâmpa',
    location: 'Brașov, Transylvania',
    region: 'Transylvania',
    description: 'A Saxon gem framed by the Carpathians, with a grand medieval square, the towering Black Church, and Mount Tâmpa rising right above the rooftops.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783697595494_7f67a60c.jpg',
    alt: 'The Council Square of Brașov Old Town, Romania, a colourful medieval Saxon town square framed by the Carpathian Mountains.',
    price: 'From €68',
    rating: 4.8,
    features: ['Council Square', 'Black Church', 'Tâmpa Cable Car'],
    category: 'mountain',
  },
  {
    id: 9,
    name: 'Bigăr & Cheile Nerei',
    location: 'Caraș-Severin, Banat',
    region: 'Banat',
    description: 'A fairytale moss-draped waterfall and emerald gorges hidden deep in the Anina Mountains, where turquoise rivers carve through wild limestone canyons.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406901686_8dd8183f.jpg',
    alt: 'The moss-covered Bigăr Waterfall in the Anina Mountains of Banat, Romania, cascading over a rounded travertine dome.',
    price: 'From €55',
    rating: 4.7,
    features: ['Bigăr Waterfall', 'Nera Gorges', 'Hiking Trails'],
    category: 'nature',
  },
  {
    id: 10,
    name: 'Carpathian Wilderness',
    location: 'Piatra Craiului, Transylvania',
    region: 'Carpathian Mountains',
    description: 'Pristine ridge-line trails, alpine meadows, and one of Europe\'s last great wildernesses, home to brown bears, wolves, and lynx in protected national parks.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406931392_5b35878a.jpg',
    alt: 'The dramatic limestone ridge of the Piatra Craiului Mountains in the Romanian Carpathians, prime wildlife and hiking territory.',
    price: 'From €60',
    rating: 4.8,
    features: ['National Park', 'Bear Watching', 'Ridge Hikes'],
    category: 'mountain',
  },
  {
    id: 11,
    name: 'Sibiu Historic Centre',
    location: 'Sibiu, Transylvania',
    region: 'Transylvania',
    description: 'A former European Capital of Culture with pastel Saxon façades, the famous "eyes of Sibiu" rooftops, cobbled squares, and a thriving arts scene.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406947493_df28616a.jpg',
    alt: 'The Large Square (Piața Mare) of Sibiu, Romania, a historic Saxon town centre with pastel façades and baroque buildings.',
    price: 'From €62',
    rating: 4.7,
    features: ['Saxon Old Town', 'Brukenthal Museum', 'Cultural Capital'],
    category: 'heritage',
  },
  {
    id: 12,
    name: 'Black Sea Coast',
    location: 'Constanța & Mamaia, Dobruja',
    region: 'Black Sea Coast',
    description: 'Golden sandy beaches, lively seaside resorts, and the ancient port of Constanța where Roman mosaics meet sun-soaked Black Sea promenades.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406964465_4a7ff604.jpg',
    alt: 'The sandy beach and resort skyline of Mamaia on the Black Sea coast near Constanța, Romania.',
    price: 'From €58',
    rating: 4.5,
    features: ['Sandy Beaches', 'Roman Heritage', 'Seaside Resorts'],
    category: 'beach',
  },
  {
    id: 13,
    name: 'Corvinilor Castle',
    location: 'Hunedoara, Transylvania',
    region: 'Transylvania',
    description: 'One of Europe\'s greatest Gothic-Renaissance castles, the Corvin Castle rises on a rocky outcrop with soaring towers, a dramatic wooden drawbridge, and centuries of Transylvanian legend.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782931605636_6ebf6fd1.jpeg',
    alt: 'Corvinilor (Corvin) Castle in Hunedoara, Transylvania, Romania, a Gothic-Renaissance fortress with red spires and a wooden drawbridge at sunset.',
    price: 'From €88',
    rating: 4.9,
    features: ['Gothic-Renaissance', 'Hunyadi Legend', 'Drawbridge'],
    category: 'heritage',
  },
];


export const regionsRomania = ['All', 'Transylvania', 'Carpathian Mountains', 'Wallachia', 'Bucovina', 'Danube Delta', 'Banat', 'Black Sea Coast'];
